module.exports = __webpack_public_path__ + "static/media/student-photo-next.ff144590.png";